import {
  SET_CLIENT,
  SET_SELECTED_REPORT,
  SET_SELECTED_REPORT_BY_ID,
  LOG_OUT,
} from '../constants';

import {
  parseClientData
} from '../../utilities/report-helpers';


const initialState = {
  reportDataLoaded: false,
  availableReports: [],
  reports: [],
  reportLinks: [],
  organisationsDictionary: {},
  defaultReportPath: '/',
  reportSelectOptions: [],
  selectedReport: {},
  clientError:false
};


const reports = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case SET_CLIENT:
      return {
        ...state,
        reportDataLoaded: true,
        ...parseClientData(action.data),
      };
    case SET_SELECTED_REPORT:
      return {
        ...state,
        selectedReport: action.report,
      };
    case SET_SELECTED_REPORT_BY_ID:
      return {
        ...state,
        selectedReport: state.reportDictionary[action.report].selectOption,
      };
    default:
      return state;
  }
};

export default reports;
